export default class EMB_MachineModel {
    constructor() {
        this.id = 0;
        this.name = "";
        this.controllerModel = "";
        this.needleBarCount = 0;
        this.headCount = 0;
        this.ipAddress = "";
        this.isActive = true;
        this.needleBars = [];
    }
}
